export enum TaskDurum {
    SIRADA=1,
    ISLENIYOR,
    BITTI_BASARILI,
    BITTI_HATALI,
    /**
     * Paket başlamış ama şu an çalışmıyor: birim beklemesinde, sırası gelmemiş
     * ya da işi bitmiş kapanmayı bekliyor. Bot tek görev işlediği için aynı
     * anda yalnızca bir paket ISLENIYOR olabilir; diğerleri buraya düşer.
     * (Eski adı ERTELENDI idi, hiç kullanılmıyordu.)
     */
    BEKLEMEDE,
    DURAKLATILDI,
    IPTAL_EDILDI,
    BITTI_EKSIK,
    YENIDEN_BASLATILDI
}